import { render, staticRenderFns } from "./VisitRemoveModal.vue?vue&type=template&id=3c029562&"
import script from "./VisitRemoveModal.vue?vue&type=script&lang=js&"
export * from "./VisitRemoveModal.vue?vue&type=script&lang=js&"
import style0 from "./VisitRemoveModal.vue?vue&type=style&index=0&id=3c029562&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports